import React from "react";
import {
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Tooltip,
} from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import SettingsIcon from "@mui/icons-material/Settings";
import ColorLensIcon from "@mui/icons-material/ColorLens";

const SettingsMenu = ({
  anchorEl,
  onClose,
  onUserProfile,
  onSystemPreferences,
  onThemeSettings,
  hasPermission,   
  collapsed,       
}) => {
  const menuItems = [
    {
      label: "Profile Settings",
      icon: <AccountCircleIcon fontSize="small" />,
      onClick: onUserProfile,
      permission: "manage_profile",
    },
    {
      label: "System Preferences",
      icon: <SettingsIcon fontSize="small" />,
      onClick: onSystemPreferences,
      permission: "manage_system",
    },
    {
      label: "Theme Settings",
      icon: <ColorLensIcon fontSize="small" />,
      onClick: () => {
        onThemeSettings();
        onClose();
      },
      permission: "manage_theme",
    },
  ];

  return (
    <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={onClose}>
      {menuItems.map(({ label, icon, onClick, permission }) =>
        hasPermission(permission) ? (
          <Tooltip key={label} title={collapsed ? label : ""} placement="right">
            <MenuItem
              onClick={() => {
                onClick();
                onClose();
              }}
            >
              <ListItemIcon>{icon}</ListItemIcon>
              {!collapsed && <ListItemText>{label}</ListItemText>}
            </MenuItem>
          </Tooltip>
        ) : null
      )}
    </Menu>
  );
};

export default SettingsMenu;
